import React from "react";
import PropTypes from "prop-types";
import * as DomainConstants from "../../constants/DomainConstants";
import { orderByPropertyName } from "../../util/orderBy";
import { Popup } from 'semantic-ui-react';

const InfrastructurenInDeBuurtTable = props => {
	const {
		infrastructurenInDeBuurt,
		disabled
	} = props;

	const onDelete = (i, tienMinutenWandelen) => {
		return function (event) {
			return props.onDelete(event, i, tienMinutenWandelen);
		};
	};
	const onEdit = (i) => {
		return function (event) {
			return props.onEdit(event, i);
		};
	};


	function findById(id, spakkiid) {
		let type = props.soortenInfrastructuurAll.find(x => x.id === id);
		if (type) {
			return type.description;
		}
		else {
			type = props.soortenInfrastructuurAll.find(x => x.id === spakkiid);

			if (type) {
				return type.description;
			}
		}
		return "Geen Type";
	}
	const infrastructurenRows = orderByPropertyName(infrastructurenInDeBuurt, "naam").map((infrastructuur, i) => {
		const isTypeAndere = infrastructuur.soortInfrastructuurId == DomainConstants.ANDERE_INFRASTRUCTUUR_GUID
			? (<span><br />{infrastructuur.andereInfrastructuur}</span>)
			: "";
		const spakkiId = infrastructuur.spakki ? infrastructuur.spakki.soortInfrastructuurId : "";
		return (
			<tr key={i}>
				<td>{infrastructuur.naam}</td>
				<td>{findById(infrastructuur.soortInfrastructuurId, spakkiId)}{isTypeAndere}</td>
				{disabled
					? null
					: <td>
						{infrastructuur.spakkiid == null ?
							<span>
								{(infrastructuur.behoortTotMijnProject) ? null : <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={onEdit(infrastructuur.id)}/>} content="Wijzig infrastructuur" /></span>}
								{(infrastructuur.behoortTotMijnProject || infrastructuur.tienMinutenWandelenInAndereInfrastructuur) ? null : <span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-trash fa-fw" onClick={onDelete(i, infrastructuur.tienMinutenWandelen)}/>} content="Verwijder infrastructuur" /></span>}
							</span>
							: null}
					</td>}
			</tr>);
	});

	const minWidth = disabled ? 0 : 6;
	return (
		<table className="c-table hours">
			<thead>
				<tr>
					<th width="35%">NAAM VAN DE INFRASTRUCTUUR</th>
					<th width="20%">TYPE</th>
					{disabled ? null : <th width={minWidth + "%"}/>}
				</tr>
			</thead>
			<tbody>
				{infrastructurenRows}
			</tbody>
		</table>
	);
};

// ----------------------------------------------------------------------------
InfrastructurenInDeBuurtTable.propTypes = {
	infrastructurenInDeBuurt: PropTypes.arrayOf(PropTypes.object),
	disabled: PropTypes.bool,
	soortenInfrastructuur: PropTypes.array,
	soortenInfrastructuurAll: PropTypes.array,
	onDelete: PropTypes.func,
	onEdit: PropTypes.func
};

export default InfrastructurenInDeBuurtTable;
